// class DonationAmountSync {
//   constructor() {
//     this.cards = document.querySelectorAll(".donation-card");
//     this.init();
//   }

//   init() {
//     if (!this.cards.length) return;

//     this.cards.forEach(card => {
//       card.addEventListener("click", () => {
//         const amount = card.dataset.amount;
//         this.selectGiveAmount(amount);
//         this.setActiveCard(card);
//       });
//     });
//   }

//   selectGiveAmount(amount) {
//     console.log("Selecting amount:", amount);
//     const giveButtons = document.querySelectorAll(
//       ".givewp-fields-amount__level"
//     );

//     giveButtons.forEach(btn => {
//         console.log("Checking button:", btn.textContent);
//       const value = btn.textContent.replace(/[^0-9]/g, "");

//       if (value === amount) {
//         console.log("Clicking button for amount:", amount);
//         btn.click(); // IMPORTANT: triggers GiveWP JS
//       }
//     });
//     console.log("Finished selecting amount:", amount);
//   }

//   setActiveCard(activeCard) {
//     this.cards.forEach(card => {
//       card.classList.remove("donation-card-active");
//     });

//     activeCard.classList.add("donation-card-active");
//   }
// }

class DonationAmountSync {
  constructor() {
    this.cards = document.querySelectorAll(".donation-card");
    this.iframe = document.querySelector("#give-form-shortcode-1");

    console.log("Donation cards found:", this.cards.length);
    console.log("Iframe found:", this.iframe);

    if (!this.cards.length || !this.iframe) return;

    this.init();
  }

  init() {
    this.iframe.addEventListener("load", () => {
      console.log("Iframe loaded");

      this.iframeDoc =
        this.iframe.contentDocument || this.iframe.contentWindow.document;

      console.log("Iframe document:", this.iframeDoc);

      this.waitForGiveButtons();
    this.bindCardClicks();
    this.watchCustomAmountInput();
    this.watchFormStep();
    this.watchDonationType();
    });
  }

  waitForGiveButtons() {
    const checkButtons = setInterval(() => {
      const giveButtons = this.iframeDoc.querySelectorAll(
        ".givewp-fields-amount__level"
      );

      console.log("Checking GiveWP buttons:", giveButtons.length);

      if (giveButtons.length) {
        console.log("GiveWP buttons found:", giveButtons);
        clearInterval(checkButtons);
      }
    }, 500);
  }

  bindCardClicks() {
    this.cards.forEach(card => {
      card.addEventListener("click", () => {
        const amount = card.dataset.amount;

        console.log("Card clicked amount:", amount);

        this.selectGiveAmount(amount);
        this.setActiveCard(card);
      });
    });
  }

  selectGiveAmount(amount) {
  if (!this.iframeDoc) {
    console.log("Iframe document not ready");
    return;
  }

  const giveButtons = this.iframeDoc.querySelectorAll(
    ".givewp-fields-amount__level"
  );

  console.log("Give buttons inside iframe:", giveButtons.length);

  giveButtons.forEach(btn => {
    const value = parseFloat(
      btn.textContent.replace(/[^0-9.]/g, "")
    );

    console.log("Checking button:", value);

    if (value == amount) {
      console.log("MATCH FOUND → Clicking GiveWP button");
      btn.click();
    }
  });
}

  setActiveCard(activeCard) {
    this.cards.forEach(card => {
      card.classList.remove("donation-card-active");
    });

    activeCard.classList.add("donation-card-active");
  }

  watchCustomAmountInput() {
  const customInput = this.iframeDoc.querySelector(
    "#amount-custom"
  );

  if (!customInput) {
    console.log("Custom amount input not found");
    return;
  }

  console.log("Custom amount input found");

  customInput.addEventListener("input", () => {
    const value = customInput.value.trim();

    console.log("Custom amount typed:", value);

    if (value !== "") {
      this.clearActiveCards();
    }
  });
}
clearActiveCards() {
  this.cards.forEach(card => {
    card.classList.remove("donation-card-active");
  });
}

watchFormStep() {
  const steps = this.iframeDoc.querySelectorAll(
    ".givewp-donation-form__step"
  );

  if (!steps.length) {
    console.log("GiveWP steps not found");
    return;
  }

  console.log("Watching step visibility changes");

  const checkStep = () => {
    let activeStepIndex = 0;

    steps.forEach((step, index) => {
      if (step.classList.contains("givewp-donation-form__step--visible")) {
        activeStepIndex = index;
      }
    });

    console.log("Active step:", activeStepIndex);

    if (activeStepIndex !== 0) {
      this.disableCards();
    } else {
      this.enableCards();
    }
  };

  // run initially
  checkStep();

  const observer = new MutationObserver(() => {
    checkStep();
  });

  steps.forEach(step => {
    observer.observe(step, {
      attributes: true,
      attributeFilter: ["class"]
    });
  });
}

disableCards() {
  this.cards.forEach(card => {
    card.classList.add("donation-card-disabled");
    card.style.pointerEvents = "none";
  });
}

enableCards() {
  this.cards.forEach(card => {
    card.classList.remove("donation-card-disabled");
    card.style.pointerEvents = "auto";
  });
}

watchDonationType() {
  const radios = this.iframeDoc.querySelectorAll(
    '.givewp-fields-radio-subscriptionPeriod input[type="radio"]'
  );

  if (!radios.length) {
    console.log("Subscription radios not found");
    return;
  }

  console.log("Watching donation type toggle");

  const updatePeriodText = (value) => {
    const periodText = document.querySelectorAll(".amount-period");

    periodText.forEach(el => {
      if (value.toLowerCase().includes("month")) {
        el.style.display = "inline";
      } else {
        el.style.display = "none";
      }
    });
  };

  radios.forEach(radio => {
    radio.addEventListener("change", () => {
      console.log("Donation type changed:", radio.value);
      updatePeriodText(radio.value);
    });

    // run on load if already selected
    if (radio.checked) {
      updatePeriodText(radio.value);
    }
  });
}

}

export default DonationAmountSync;